import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export default function ThemeToggle({ className = "", size = "md" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const dims =
    size === "sm" ? "w-8 h-8" :
    size === "lg" ? "w-11 h-11" :
    "w-9 h-9";

  return (
    <button
      type="button"
      data-testid="theme-toggle"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      onClick={toggle}
      className={`${dims} grid place-items-center rounded-full border transition-all
        bg-slate-100 hover:bg-slate-200 border-slate-300 text-slate-700
        dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-slate-700 dark:text-slate-200
        ${className}`}
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
